<script>
// http://localhost/?quicklink=ab179953847292efbcbf56949ac61901
import { componentStore } from "@common/componentStore/componentStore";
import { uStore } from "@common/userStore";
import { library } from "@common/library/library";
import JsonViewer from 'vue-json-viewer';
import moment from 'moment';
import { defineAsyncComponent } from "@common/defineAsyncComponent";

const editorSettings = {
    // no editor settings
};

const historyComponentConfig = {
    cId: "historyComponent",
    cType: "historyComponent",
    cTitle: "Component History Reviewer",
    cTemplate: `
<div style="margin: 0.5rem 1rem;">
    <div style="display: flex;">
        <div style="padding: 0 1rem 1rem; flex: 1;">
            <div style="display: flex;align-items: flex-end;margin-bottom: 1rem;">
                <control class="selected-component_value" name="SELECTED_COMPONENT" style="padding: 0 1rem;height: 80px;" :style="{ 'width': selectedComponentConfig.cId ? '97%' : '42%' }"></control>
                <control name="CLEAR_SELECTION" v-if="!componentIsUpdating && selectedComponentConfig.cId"></control>
            </div>{{history.length}} - {{componentIsUpdating}} - {{selectedComponentConfig.cId}}
            <div v-if="!componentIsUpdating && selectedComponentConfig.cId && !history.length" class="alert alert-warning"
                 style="background: #f3d9dd; border: 1px solid #e9e9e9; margin: 1rem; padding: 1rem;width: fit-content;">
                There is no available aaa history for the component you selected.<br>Please choose a different one.
            </div>
            <div v-if="selectedComponentConfig && history.length">
                <div>
                    <condensed-filter
                            cId="condensedFilter__history"
                            :prop-filter-options="filterOptions"
                            :prop-filter-items="history"
                            :prop-result="filteredItems"
                            @update:prop-result="filteredItems = $event"
                            :prop-filtering=false
                            @update:prop-filtering="filtering = $event"
                            :prop-item-label="filteredItems.length >= 1 ? 'History States' : 'History State'"
                    ></condensed-filter>
                </div>
                <div>
                    <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
                        <h2 style="padding-left: 0.275rem;">Find and Select a History State</h2>
                    </div>
                    <div>
                         <table class="table" style="border-spacing: 1px;">
                            <thead>
                                <tr>
                                    <th style="text-align: left;padding: 0.25rem 0.5rem 0; min-width: 200px;" scope="col">Date Modified:</th>
                                    <th style="text-align: left;padding: 0.25rem 0.5rem 0; min-width: 200px;" scope="col">Items Changed:</th>
                                    <th style="text-align: left;padding: 0.25rem 0.5rem 0; min-width: 150px;" scope="col">User:</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr  v-for="(item, idx) in filteredItems" :key="idx" id="historyList" class="component-item" :class="{ active: idx === currentIndex }" @click="previewSelectedState(idx)">
                                    <td style="padding: 0.75rem 1.25rem 1rem;vertical-align: top;text-align: center;">{{item.formattedDate}}<br>{{ idx }}: {{ item.PROFILE_HISTORY_ID }}</td>
                                    <td style="padding: 0.75rem 1.25rem 1rem;vertical-align: top;display: flex;flex-wrap: wrap;line-height: 1.75rem;">
                                        <span v-for="(data, index) in item.elementsModified" style="font-size: 1.1rem;">{{data}} ,</span>
                                    </td>
                                    <td style="padding: 0.75rem 1.25rem 1rem;vertical-align: top;">
                                        <span v-if="item.PROFILE_HISTORY_OWNER_USERNAME">{{item.PROFILE_HISTORY_OWNER_USERNAME}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="!filteredItems.length && !componentIsUpdating" class="alert alert-warning" style="padding: 1rem 0;">
                            No history entries match your filters.
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="selectedComponentConfig.cId" style="flex: 1;">
            <div style="padding: 0.5rem 0 1.5rem;">
                <div style="display: flex;justify-content: space-between;align-items: center;flex-wrap: wrap;margin: 1rem 3rem 1.5rem;">
                   <h2 style="color: #333;margin: 0;padding-left: 0.275rem;">Selected Component Details</h2>
                   <control v-if="currentIndex !== 0" class="save_btn" name="SAVE_BUTTON"
                       style="width: fit-content;"></control>
                </div>
                <div style="margin: 1rem;">
                    <div v-if="currentComponentState" style="padding: 0 1rem;">
                        <tab-list cId="tabList_historyComponent-tab" :prop-tabs-list="editorTabs">
                            <template #tabList_item_0 style="border: 1px solid #e0e0e0;">
                                <component v-if="!componentIsUpdating && currentComponentState.cId" :is="currentComponentState.cType"
                                   :cId="currentComponentState.cId"
                                   :providedConfig="currentComponentState">
                                </component>
                            </template>
                            <template #tabList_item_1>
                                <div style="display:flex;">
                                    <div style="flex: 1;">
                                        <h3>Current Change</h3>
                                        <json-viewer
                                            :value="selectedHistoryEntry.newValueJSON"
                                            :expand-depth=5
                                            placeholder="New Value JSON"
                                            copyable
                                            sort></json-viewer>
                                    </div>
                                    <div style="flex: 1;">
                                        <h3>Previous Change</h3>
                                        <json-viewer
                                            :value="selectedHistoryEntry.oldValueJSON"
                                            :expand-depth=5
                                            placeholder="Previous Value JSON"
                                            copyable
                                            sort></json-viewer>
                                    </div>
                                </div>
                            </template>
                            <template #tabList_item_2>
                                <div>
                                    <json-viewer
                                        :value="currentComponentState"
                                        :expand-depth=5
                                        copyable
                                        sort></json-viewer>
                                </div>
                            </template>
                        </tab-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>`,

    controls: [
        {
            name: 'SELECTED_COMPONENT',
            label: 'Select a Component',
            id: 'selectedComponentId',
            type: 'dropdown',
            itemsSource: 'componentStore.getList(true, true)',
            itemsFilter: 'this.item.cType !== "historyComponent"',
            fields: { text: 'cId', value: 'cId' },
            allowFiltering: true,
            popupWidth: '500px',
            filterType: 'Contains',
            default: [],
            onchange: 'selectComponent',
            placeholder: 'Begin typing or scroll through the dropdown to select a component'
        },
        {
            name: 'HISTORY',
            type: 'boolean',
            label: 'Show History',
            onclick: 'buttonActionHide',
            cssClass: ''
        },
        {
            name: 'TOGGLE_VIEW',
            type: 'boolean',
            label: 'Show JSON / Preview',
            onclick: 'toggleJSON',
            default: false,
            cssClass: ''
        },
        {
            name: 'CLEAR_SELECTION',
            type: 'button',
            label: 'Clear Selection',
            onclick: 'resetSelection',
            cssClass: ''
        },
        {
            name: 'GET_HISTORY',
            type: 'button',
            label: 'GET_History',
            onclick: 'historyButton',
            cssClass: ''
        },
        {
            name: 'SELECT_BUTTON',
            type: 'button',
            label: 'Preview',
            onclick: 'previewSelectedState',
            cssClass: ''
        },
        {
            name: 'UNDO_BUTTON',
            type: 'button',
            label: 'Previous',
            onclick: 'previousAction',
            cssClass: ''
        },
        {
            name: 'REDO_BUTTON',
            type: 'button',
            label: 'Redo',
            onclick: 'redoAction',
            cssClass: ''
        },
        {
            name: 'SAVE_BUTTON',
            type: 'button',
            label: 'Save Component with this Selected History State',
            onclick: 'saveSelection',
            cssClass: ''
        }
    ]
};

const historyComponentCmp = {
    name: 'historyComponent',
    editorSettings: editorSettings,
    props: {},
    data() {
        return {
            selectedComponentConfig: false,
            componentIsUpdating: false,
            history: [],
            currentIndex: 0,
            tempIdx: [],
            newIdx: undefined,
            fields: { text: 'elementsModified', value: '' },
            filtering: false,
            filteredItems: [],
            filterOptions: {
                all: {
                    label: "All Keywords",
                    required: true,
                    type: "string"
                },
                any: {
                    label: "Any Keyword",
                    required: true,
                    type: "string"
                },
                PROFILE_HISTORY_DATE: {
                    label: 'Date of Change',
                    type: 'date'
                },
                PROFILE_HISTORY_OWNER_EMAIL: {
                    label: 'Created By',
                    required: true,
                    type: 'string'
                }
            },
            currentValue: 0,
            tempValue: 0,
            count: 0,
            componentID: '',
            editorTabs: [
                {
                    title: 'Preview',
                    useVueSlot: true,
                }, {
                    title: 'Compare Current Changes',
                    useVueSlot: true,
                }, {
                    title: 'Complete JSON',
                    useVueSlot: true,
                }
            ],
            showJSON: false
        };
    },
    computed: {
        currentComponentState() {
            let lastHistoryIndex = this.historyLength - 1;
            // Always start with the current saved configuration
            let selectedState = library.cloneObj(this.selectedComponentConfig);
            // If this.currentIndex is 0, then we are looking at the live state, not history
            if (this.currentIndex <= lastHistoryIndex) {
                let history = library.cloneObj(this.history);
                // loop through history entries in reverse, except the first one, and merge
                for (let hIndex = 1; hIndex <= this.currentIndex; hIndex++) {
                    let historyEntry = history[hIndex];
                    // Get the state changes from the history entries
                    // Most entries will merge from the oldValueJSON, but the oldest entry will come from newValueJSON
                    // We are also ignoring the newest entry, as it is a placeholder representing current state (it's not history)
                    let hEntryKey = hIndex === lastHistoryIndex ? 'newValueJSON' : 'oldValueJSON';
                    // This is where we started, the last entry is current state
                    // This displays in reverse in the UI (showing the last item "current
                    if (hIndex !== lastHistoryIndex) library.mergeWith(selectedState, historyEntry[hEntryKey]);
                }
            }
            return selectedState;
        },
        selectedHistoryEntry() {
            let selectedState = library.cloneObj(this.selectedComponentConfig);
            if (this.currentIndex > 0) selectedState = this.history[this.currentIndex];
            return selectedState;
        },
        historyLength() {
            return this.history.length;
        },
    },
    methods: {
        onLoad() {
            uStore().getUserData().then((user) => {
                this.user = user;
            });
        },
        resetSelection() {
            this.controls.SELECTED_COMPONENT.value = null;
            this.selectedComponentConfig = false;
            this.history = [];
            this.filteredItems = [];
            this.currentIndex = 0;
        },
        async selectComponent() {
            const id = this.controls.SELECTED_COMPONENT.value;
            if (!id) {
                this.resetSelection();
                return;
            }
            this.componentId = id;
            this.componentIsUpdating = true;
            let componentConfig = await componentStore.getConfig(id);
            this.selectedComponentConfig = componentConfig;
            const response = await this.sDs.post('sds_getComponentHistory', id);
            if (response.status === 'success' && Array.isArray(response.data) && response.data.length) {
                let parseJSON = (hItem) => {
                    hItem.newValueJSON = library.isJson(hItem.PHD_NEW_VALUE) ? JSON.parse(hItem.PHD_NEW_VALUE) : hItem.PHD_NEW_VALUE;
                    hItem.oldValueJSON = library.isJson(hItem.PHD_OLD_VALUE) ? JSON.parse(hItem.PHD_OLD_VALUE) : hItem.PHD_OLD_VALUE;
                    return hItem;
                };
                let formatDate = (hItem) => {
                    if (hItem.PROFILE_HISTORY_DATE === 'Current State') hItem.formattedDate = 'Current State';
                    else if (hItem.PROFILE_HISTORY_DATE) hItem.formattedDate = moment(hItem.PROFILE_HISTORY_DATE).format('MMMM Do YYYY, h:mm:ss');
                    return hItem;
                };
                let getChangesList = (hItem) => {
                    if (!hItem.newValueJSON || typeof hItem.newValueJSON !== 'object') return hItem;
                    let excludedKeys = ['daysSinceLastModify', 'cLastModifyUnixDay', 'cCreatedDate'];
                    hItem.elementsModified = Object.keys(hItem.newValueJSON).filter((key) => excludedKeys.indexOf(key) === -1);
                    return hItem;
                };
                // Reverse the data: Newest Entry First
                response.data.reverse();
                let currentStateEntry = {
                    PHD_NEW_VALUE: null,
                    PHD_OLD_VALUE: JSON.stringify(componentConfig),
                    PROFILE_HISTORY_DATE: 'Current State'
                };
                let history = [currentStateEntry, ...response.data];
                history = history.map(formatDate);
                history = history.map(parseJSON);
                history = history.map(getChangesList);
                this.history = history;
                this.currentIndex = 0;
            } else if (response.status === 'failure' || !response.data.length) {
                this.history = [];
            }
            setTimeout(() => {
                this.componentIsUpdating = false;
            }, 1000); // NOSONAR
        },
        previewSelectedState(index) {
            this.currentIndex = index;
        },
        async saveSelection() {
            const response = await library.showDialog('By saving, you are updating the original component. This will become the new history state, appended to the previous so you will still be able to view all history states.');
            if (response.status === 'success') {
                componentStore.saveComponent(this.selectedHistoryCompConfig);
                await this.selectComponent();
            }
        }
    },
    components: {
        JsonViewer,
        condensedFilter: defineAsyncComponent(() => import('@common/condensedFilter/condensedFilter.vue')),
        'tabList': defineAsyncComponent(() => import('@common/tabList/tabList.vue')),
    }
};
componentStore.initComponent(historyComponentCmp, historyComponentConfig, '@components/historyComponent.vue');

export { historyComponentConfig, historyComponentCmp };
export default historyComponentCmp;
</script>

<style scoped>
.component-name {
    font-size: 15px;
    white-space: nowrap;
    min-width: 75px;
}
.component-item {
    background: #eee;
    cursor: pointer;
}
.component-item.active,
.component-item:hover {
    background: #f3d9dd !important;
}
.component-list-main-details {
    display: block;
}
:deep(.e-tab .e-content) {
    padding: 1rem 0;
}
:deep(.save_btn button.active) {
    background: #2c2a7a;
    color: #fff;
    padding: 0.5rem 1rem;
    font-weight: 600;
    letter-spacing: 0.2px;
}
:deep(.e-tab .e-tab-header .e-toolbar-items) {
    margin-left: 2rem;
}
:deep(.save_btn button.active):hover {
    background: #a82c2c;
}
.json-viewer {
    display: flex;
    margin-bottom: 2rem;
}
.jv-container.jv-light {
    border: 1px solid #ececec;
}
</style>
